export const AUTH_CONFIG = {
    domain: 'dev-ktt11zj0.eu.auth0.com',
    clientId: 'Ucf5ivlMXNkhh7M9TnvqbRszckPIlbKW',
    callbackUrl: 'https://rodeo.now.sh/callback',
    audience: "https://localhost:5001/graphql"
}